export default "__VITE_ASSET__LDRYHjHU__"